import React from 'react';

export default function Logo() {
  return (
      <div className="top">
        <h1 style={{height: "40px", margin: "10px", color: "#FFF"}}>BizHost</h1>
      </div>
  );
}
